var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer text-center"},[_c('p',{staticClass:"white"},[_vm._v("created by hzzly")])])}]

export { render, staticRenderFns }